import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getToken, setToken, clearToken, fetchMe, verifySigil, sealOath } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  // null = checking, false = not authenticated, object = member
  const [member, setMember] = useState(getToken() ? null : false);

  useEffect(() => {
    if (!getToken()) {
      setMember(false);
      return;
    }
    fetchMe()
      .then(setMember)
      .catch(() => {
        clearToken();
        setMember(false);
      });
  }, []);

  const enterWithSigil = useCallback(async (sigil) => {
    const data = await verifySigil(sigil);
    setToken(data.token);
    const me = await fetchMe();
    setMember(me);
    return me;
  }, []);

  const seal = useCallback(async () => {
    const me = await sealOath();
    setMember(me);
    return me;
  }, []);

  const logout = useCallback(() => {
    clearToken();
    setMember(false);
  }, []);

  return (
    <AuthContext.Provider value={{ member, enterWithSigil, seal, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
